import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";
import { 
  HomePage, 
  ServicesPage, 
  PeoplePage, 
  InsightsPage, 
  ContactPage 
} from "./pages";
import ArticlePage from "./pages/ArticlePage";
import AdminPage from "./pages/AdminPage";
import GoldilocksZonePage from "./pages/GoldilocksZonePage";
import MediaSpeakingPage from "./pages/MediaSpeakingPage";
import GivingBackPage from "./pages/GivingBackPage";
import AasmaPage from "./pages/AasmaPage";
import CareerConsultsPage from "./pages/CareerConsultsPage";
import WorkshopsPage from "./pages/WorkshopsPage";
import WorkExperiencePage from "./pages/WorkExperiencePage";
import PrivacyPage from "./pages/PrivacyPage";
import { ScrollToTop } from "./components/ScrollToTop";

function App() {
  // Remove any dynamically injected badges
  useEffect(() => {
    const removeBadge = () => {
      const badge = document.getElementById('emergent-badge');
      if (badge) badge.remove();
      document.querySelectorAll('a[href*="emergent.sh"]').forEach(el => el.remove());
    };
    removeBadge();
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/people" element={<PeoplePage />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/insights/:slug" element={<ArticlePage />} />
            <Route path="/the-goldilocks-zone" element={<GoldilocksZonePage />} />
            <Route path="/media-speaking" element={<MediaSpeakingPage />} />
            <Route path="/giving-back" element={<GivingBackPage />} />
            <Route path="/giving-back/work-experience-2026" element={<WorkExperiencePage />} />
            <Route path="/giving-back/aasma-2025" element={<AasmaPage />} />
            <Route path="/giving-back/career-consults-2024" element={<CareerConsultsPage />} />
            <Route path="/giving-back/workshops-2023" element={<WorkshopsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
